/**
 * Gets the current date and time.
 *
 * @returns {Date} The current date and time.
 */
export function now () { return new Date(); }
